import(/* webpackMode: "eager" */ "/tmp/8def0913fcb00a8/src/app/chat/page.tsx");
